import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { resolveRleventsAccess } from "@/lib/rleventsAccess";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import AccessRetryBanner from "@/components/auth/AccessRetryBanner";

const DashboardContent: React.FC = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth() as any;
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => {
    setFailed(false);
    setAttempt((a) => a + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (isLoading) return;
      if (!user) {
        navigate("/auth/login", { replace: true });
        return;
      }
      const access = await resolveRleventsAccess(user.id, { force: attempt > 0 });
      if (cancelled) return;
      if (access.status !== "ok") {
        // Unknown is not "no access" — never send a signed-in user away on this.
        setFailed(true);
        return;
      }
      navigate(access.landingPath, { replace: true });
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [user?.id, isLoading, navigate, attempt]);

  if (failed) return <AccessRetryBanner onRetry={retry} />;

  return (
    <div className="flex items-center justify-center p-8">
      <p>Redirecting…</p>
    </div>
  );
};

const Dashboard: React.FC = () => (
  <ErrorBoundary componentName="Dashboard">
    <DashboardContent />
  </ErrorBoundary>
);

export default Dashboard;
